import ProcessEnvironment from "@/constants/ProcessEnvironment";

// Helper function to build upload URLs
const buildUploadUrl = (endpoint: string) => {
  return `${ProcessEnvironment.ApiGateway}${endpoint}`;
};

export { buildUploadUrl };
